export enum USER_ROLES {
  AI_SEARCH = 'AI_SEARCH',
  INFRINGEMENT_DETECTION = 'INFRINGEMENT_DETECTION',
  INVENTION_DISCLOSURE = 'INVENTION_DISCLOSURE',
  FTO = 'FTO',
  ORG_ADMIN = 'ORG_ADMIN',
  PLATFORM_ADMIN = 'PLATFORM_ADMIN',
  DEVELOPER_ADMIN = 'DEVELOPER_ADMIN',
  DEVELOPER = 'DEVELOPER',
  CHEMISTRY = 'CHEMISTRY',
  PATENT_DRAFT = 'PATENT_DRAFT',
  CHEMICAL_DRAFT = 'CHEMICAL_DRAFT',
  DISCLOSURE_DRAFT = 'DISCLOSURE_DRAFT',
  AI_SEARCH_QUERY = 'AI_SEARCH_QUERY',
  PUBLICATION_TRACKER = 'PUBLICATION_TRACKER',
  OFFICE_ACTION = 'OFFICE_ACTION',
  IMAGE_GENERATION = 'IMAGE_GENERATION',
  IMAGE_GENERATION_V2 = 'IMAGE_GENERATION_V2',
  MILETUS = 'MILETUS',
  ORG_CUSTOM_INSTRUCTION = 'ORG_CUSTOM_INSTRUCTION',
  LITIGATION_ASSISTANT = 'LITIGATION_ASSISTANT',
  SEQUENCES = 'SEQUENCES',
  DICTATION = 'DICTATION',
  CONFERENCE_ADMIN = 'CONFERENCE_ADMIN',
  GENERAL_ASSISTANT = 'GENERAL_ASSISTANT',
  INVENTION_ASSISTANT = 'INVENTION_ASSISTANT',
  KNOWLEDGE_ADMIN = 'KNOWLEDGE_ADMIN',
}

export enum WORKFLOWS {
  ANTICIPATION = 'ANTICIPATION',
  INFRINGEMENT_DETECTION = 'INFRINGEMENT_DETECTION',
  INVENTION_DISCLOSURE = 'INVENTION_DISCLOSURE',
  FTO = 'FTO',
  PATENT_DRAFT = 'PATENT_DRAFT',
  DISCLOSURE_DRAFT = 'DISCLOSURE_DRAFT',
  AI_SEARCH = 'AI_SEARCH',
  CONCEPT_SEARCH = 'CONCEPT_SEARCH',
  OFFICE_ACTIONS = 'OFFICE_ACTIONS',
  ORG_MANAGEMENT = 'ORG_MANAGEMENT',
  PLATFORM_MANAGEMENT = 'PLATFORM_MANAGEMENT',
  FEATURES_FLAGS_VIEW = 'FEATURES_FLAGS_VIEW',
  DEVELOPER_MANAGEMENT = 'DEVELOPER_MANAGEMENT',
  DEVELOPER = 'DEVELOPER',
  PATENT_INTELLIGENCE = 'PATENT_INTELLIGENCE',
  LITIGATION_ASSISTANT = 'LITIGATION_ASSISTANT',
  CONFERENCE_MANAGEMENT = 'CONFERENCE_MANAGEMENT',
  GENERAL_ASSISTANT = 'GENERAL_ASSISTANT',
  INVENTION_ASSISTANT = 'INVENTION_ASSISTANT',
}

export enum FEATURES {
  IMAGE_GENERATION = 'IMAGE_GENERATION',
  IMAGE_GENERATION_V2 = 'IMAGE_GENERATION_V2',
  CHEMISTRY = 'CHEMISTRY',
  SEQUENCES = 'SEQUENCES',
  DICTATION = 'DICTATION',
  PATENT_DRAFTING_MECHANICAL_MODE = 'PATENT_DRAFTING_MECHANICAL_MODE',
  PATENT_DRAFTING_CHEMICAL_MODE = 'PATENT_DRAFTING_CHEMICAL_MODE',
  FORCE_ACTIVE_KNOWLEDGE = 'FORCE_ACTIVE_KNOWLEDGE',
}
